import styled, { css, keyframes } from 'styled-components';
import { COLORS, monoLabel, monoValue } from '../../lib/theme';

/**
 * The overlay plate every HUD readout sits on. Type is never set directly on
 * video -- the navy fill is what keeps mono labels legible over a
 * photographic ground. It is translucent (see COLORS.plateFill) so the frame
 * shows through the plate, but the type itself is always at full alpha.
 *
 * `$priority` adds the 2px yellow top edge that marks the one priority plate
 * in a feed. At most one per panel.
 */
const Plate = styled.div`
  position: absolute;
  background: ${COLORS.plateFill};
  border: 1px solid ${COLORS.plateBorder};
  padding: 8px;
  pointer-events: none;

  ${(p) =>
    p.$priority &&
    css`
      border-top: 2px solid ${COLORS.accent};
    `}
`;

export const Label = styled.span`
  ${monoLabel}
  font-size: 9px;
  color: ${COLORS.label};
`;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
  white-space: nowrap;
`;

export const RowLabel = styled.span`
  ${monoValue}
  color: ${COLORS.label};
`;

export const RowValue = styled.span`
  ${monoValue}
  color: ${(p) => p.$color || COLORS.text};
`;

export const Divider = styled.div`
  height: 1px;
  background: ${COLORS.hairline};
  margin: 7px -8px;
`;

const blink = keyframes`
  0%, 49.9% { opacity: 1; }
  50%, 100% { opacity: 0.25; }
`;

export const Dot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => p.$color || COLORS.live};
  flex: 0 0 auto;

  ${(p) =>
    p.$blink &&
    css`
      @media (prefers-reduced-motion: no-preference) {
        animation: ${blink} 1s steps(1) infinite;
      }
    `}
`;

export default Plate;
